

/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Dashboard 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Dashboard 2 React using thie file.
 */

const colors = {
  background: {
    default: "#0A1424",
    paper: "#1A2C49",
    sidenav: "#0E2348",
    card: "#1A2C49",
  },

  text: {
    main: "#EAF1FB",
    focus: "#AAB9D2",
    secondary: "#AAB9D2",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#A8C8FF",
    focus: "#D6E3FF",
  },

  secondary: {
    main: "#545F71",
    focus: "#677384",
  },

  info: {
    main: "#A8C8FF",
    focus: "#D6E3FF",
  },

  success: {
    main: "#1F8A56",
    focus: "#2AA669",
  },

  warning: {
    main: "#E68A06",
    focus: "#FFB400",
  },

  error: {
    main: "#BA1A1A",
    focus: "#D92D20",
  },

  light: {
    main: "#F8FAFD",
    focus: "#F8FAFD",
  },

  dark: {
    main: "#0E2348",
    focus: "#193F8C",
  },

  grey: {
    100: "#F8FAFD",
    200: "#1A2C49",
    300: "#243556",
    400: "#AAB9D2",
    500: "#8E9CB6",
    600: "#7181A0",
    700: "#56677F",
    800: "#3A4B63",
    900: "#EAF1FB",
  },

  gradients: {
    primary: {
      main: "#1565C8",
      state: "#1565C8",
    },

    secondary: {
      main: "#545F71",
      state: "#677384",
    },

    info: {
      main: "#1565C8",
      state: "#1565C8",
    },

    success: {
      main: "#1F8A56",
      state: "#1F8A56",
    },

    warning: {
      main: "#E68A06",
      state: "#E68A06",
    },

    error: {
      main: "#BA1A1A",
      state: "#BA1A1A",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#0E2348",
      state: "#0E2348",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#D6E3FF",
      text: "#001B3F",
    },

    secondary: {
      background: "#D8E3F8",
      text: "#545F71",
    },

    info: {
      background: "#003C8A",
      text: "#A8C8FF",
    },

    success: {
      background: "#D7F0E0",
      text: "#1F8A56",
    },

    warning: {
      background: "#FFDDB3",
      text: "#8A5300",
    },

    error: {
      background: "#FFDAD6",
      text: "#BA1A1A",
    },

    light: {
      background: "#ffffff",
      text: "#D6E3FF",
    },

    dark: {
      background: "#0E2348",
      text: "#FFFFFF",
    },
  },

  coloredShadows: {
    primary: "#1565C8",
    secondary: "#545F71",
    info: "#1565C8",
    success: "#1F8A56",
    warning: "#E68A06",
    error: "#BA1A1A",
    light: "#D6E3FF",
    dark: "#0E2348",
  },

  inputBorderColor: "#d2d6da",
  surface: {
    lowest: "#13223A",
    main: "#13223A",
    container: "#1A2C49",
    containerHighest: "#243556",
    variant: "#243556",
  },

  // Brand roles, mirrored from the light palette so component override files
  // can be shared between the two themes. Dark equivalents of #1565C8 /
  // #D6E3FF / #001B3F.
  brand: {
    primary: "#A8C8FF",
    primaryContainer: "#003C8A",
    onPrimaryContainer: "#D6E3FF",
    navy: "#0E2348",
  },

  outline: {
    main: "#AAB9D2",
    variant: "#243556",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
